import React, { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import {
	CONFIRM_PASSWORD_FORM_FIELD, CONFIRM_PASSWORD_FORM_FIELD_NAME,
	ConfirmPasswordFieldType,
	getConfirmPasswordDetailSchema,
	initialConfirmPasswordValue
} from '../../constants/login-modal/modal-form';
import { ConfirmPasswordInput } from '../comfirmPassword/ConfirmPasswordInput';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { shallowEqual, useSelector } from 'react-redux';
import { IAuthState } from '../../redux/AuthRedux';
import { RootState } from '../../../setup';
import { CodeModalProps, executeRecaptcha, SITE_KEY } from '../../views/login/Login';
import { login } from '../../redux/AuthCRUD';

interface Props {
	closeModal: () => void;
	logOut: () => void;
	handleSuccessLogin: (value: any) => void;
	setCodeModalState: (value: CodeModalProps) => void;
}

export const LoginModal: FC<Props> = (props) => {
	const { closeModal, logOut, setCodeModalState, handleSuccessLogin } = props;
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [loading, setLoading] = useState(false);

	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const userData = authUser.userData;

	useEffect(() => {
		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
		document.body.appendChild(script);
	}, []);

	const formik = useFormik<ConfirmPasswordFieldType>({
		initialValues: initialConfirmPasswordValue,
		validationSchema: getConfirmPasswordDetailSchema,
		onSubmit: async () => {
			if (!formik.isValid) return;
			try {
				setLoading(true);
				const recaptchaToken = await executeRecaptcha();
				const user = await login(userData.email, formik.values[CONFIRM_PASSWORD_FORM_FIELD.PASSWORD], recaptchaToken);

				if (user?.data?.daysToEnforceMFA) {
					localStorage.setItem('enforcedMFAData', JSON.stringify({
						daysLeft: user?.data?.daysToEnforceMFA,
						skipAvailable: user?.data?.skipAvailable,
					}));
				}

				if (user?.data?.session) {
					closeModal();
					setCodeModalState({
						isOpen: true,
						session: user?.data?.session,
						email: userData.email
					});
					setLoading(false);
				}

				if (user?.data?.id) {
					handleSuccessLogin(user);
				}
				setLoading(false);
			} catch (e) {
				console.log('error', e);
				logOut();
				setLoading(false);
			}
		}
	});

	return (
		<form onSubmit={formik.handleSubmit} className="px-15 mt-5">
			<div className="fs-5 mb-7">To access certain parts of the Dashboard, please confirm your password.</div>
			<div className="row change-password-container">
				<ConfirmPasswordInput
					formik={formik}
					fieldName={CONFIRM_PASSWORD_FORM_FIELD.PASSWORD}
					placeholder={CONFIRM_PASSWORD_FORM_FIELD_NAME.PASSWORD}
					label={CONFIRM_PASSWORD_FORM_FIELD_NAME.PASSWORD}
					showPassword={showPassword}
					setShowPassword={setShowPassword}
					additionalClass="password-container position-relative col-12 pb-3"
					isPasswordShown={true}
					isSmallInput
					required
					autoComplete="current-password"
				/>
			</div>
			<div className="text-center mt-10 pb-10">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={logOut}
				/>
				<ButtonComponent
					buttonName="Continue"
					type="submit"
					additionalClass="btn-sm ms-10 w-110px"
					loading={loading}
				/>
			</div>
		</form>
	);
};
